export default "__VITE_ASSET__D46YNAKB__"